import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  private readonly themeKey = 'app-theme';
  private themeSubject = new BehaviorSubject<'light' | 'dark'>('light');
  public theme$ = this.themeSubject.asObservable();

  constructor() {}

  private isBrowser(): boolean {
    return (
      typeof window !== 'undefined' &&
      typeof window.localStorage !== 'undefined'
    );
  }

  setTheme(theme: 'light' | 'dark'): void {
    if (this.isBrowser()) {
      const isDark = theme === 'dark';
      if (isDark) {
        document.body.classList.add('dark-theme');
      } else {
        document.body.classList.remove('dark-theme');
      }
      localStorage.setItem(this.themeKey, theme);
      this.themeSubject.next(theme);
    }
  }

  getTheme(): 'light' | 'dark' {
    if (this.isBrowser()) {
      const storedTheme = localStorage.getItem(this.themeKey);
      return storedTheme === 'dark' ? 'dark' : 'light';
    }
    return 'light';
  }

  toggleTheme(): void {
    const newTheme = this.themeSubject.value === 'light' ? 'dark' : 'light';
    this.setTheme(newTheme);
  }

  initTheme(): void {
    this.setTheme(this.getTheme());
  }
}
